
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FullCalendar } from 'primereact/fullcalendar';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import Messages from '../../../shared/UI/Messages/Messages';
import DropdownList from '../../../shared/UI/DropdownList/DropdownList';
import { InputText } from 'primereact/inputtext';
import * as actions from '../../../store/actions/index';
import moment from 'moment';

class WorkShedule extends Component {

    calendarRef = React.createRef()
    constructor() {
        super();
        this.state = {
            viewAs: "table",
            selectedEmployee: false,
            globalFilter: null,
            selectedCustomers: [],
            currentRange: false,
            viewAsOptions: [
                { label: "View As Table", value: "table" },
                { label: "View As Calendar", value: "calendar" }
            ],
            options: {
                plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
                defaultView: 'dayGridMonth',
                defaultDate: new Date(),
                header: {
                    left: 'prev,next',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                },
                editable: false,
                draggable: false,
                weekends: true,
                /*dateClick: (e) => {
                },
                eventClick: (info) => {
                },
                eventReceive: function (info) {
                },
                eventDrop: function (info) {
                    info.revert();
                },
                eventRender: function (event, element, view) {
                },
                eventAfterAllRender: function (view) {
                },*/
                datesRender: function ({ view }) {
                    const currentRange = view.props && view.props.dateProfile && view.props.dateProfile.currentRange;

                    this.setState({ currentRange });

                    this.props.getCalendarData(this.state.selectedEmployee, 'WorkSchedule', moment(currentRange.start).format('MM-DD-YYYY'), moment(currentRange.end).format('MM-DD-YYYY'));
                }.bind(this)

            },
            display: false
        };


    }

    // componentDidMount() {
    //     this.props.getRequest();
    // }
    // componentDidMount() {
    //     let processID = 'db4bccf0-4446-464e-ba88-28991bd6acec';
    //     let empId = localStorage.getItem('EmpId');
        
    //     // Check if data already exists for this process (navigation from dashboard)
    //     const { requestListData } = this.props;
    //     const existingData = requestListData && requestListData[0] && 
    //         requestListData[0].filter(list => list.processId === processID && list.requestFrom === "My Request");
        
    //     // Only call API if no existing data (page reload) or data is empty
    //     if (!existingData || existingData.length === 0) {
    //         // localStorage.removeItem(`Request/GetRequest?id=${empId}&processid=${processID}`);
    //         this.props.getRequest(empId, processID);
    //     }
    // }


    statusRender = (rowData, column) => {
     
        let status = <Button type="button" label="Pending" className="p-button-warning p-button-rounded" ></Button>
        if (rowData.status === null || undefined) {
            status = <Button type="button" label="Saved as Draft" className="p-button-info p-button-rounded" ></Button>
        } else if (rowData.status === 'Approved') {
            status = <Button type="button" label="Approved" className="p-button-success p-button-rounded" ></Button>
        } else if (rowData.status === 'Canceled') {
            status = <Button type="button" label="Canceled" className="p-button-danger p-button-rounded" ></Button>
        } else if (rowData.status === 'Closed') {
            status = <Button type="button" label="Closed" className="p-button-success p-button-rounded" ></Button>
        } else if (rowData.status === 'Rejected') {
            status = <Button type="button" label="Rejected" className="p-button-danger p-button-rounded" ></Button>
        }

        return <div className="actionCenter">
            {status}
        </div>;
    }

    renderHeader = () => {
        return (
            <div>
                List of Requests
                <div className="p-datatable-globalfilter-container">
                    <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Search" />
                </div>
            </div>
        );
    }

    actionTemplate = (rowData) => {
      
      return <div>      
            <Link to={{pathname: `/shift-approval-single/edit/${rowData.requestId}`, state: {
                ...rowData, editStatus: 'Closed'
            }}}>
                <Button type="button" icon="pi pi-pencil" className="p-button-info" />
            </Link>
        </div>;
    }



    render() {

        const { viewAs, viewAsOptions } = this.state;
        const { requestListData, calendarData } = this.props;
        
        const data = requestListData && requestListData[0] && requestListData[0].filter(list => list.processId === 'db5bccf0-4446-464e-ba88-28991bd6acec' && list.requestFrom === "My Request") || [];

        const DropdownChange = e => {
            const currentRange = this.state.currentRange || false;
            this.props.getCalendarData(e.target.value, 'WorkSchedule', moment(currentRange && currentRange.start || '').format('MM-DD-YYYY'), moment(currentRange && currentRange.end || '').format('MM-DD-YYYY'));
            this.setState({ selectedEmployee: e.target.value })
        }
        
        let processEvents = calendarData && calendarData.length > 0 ? calendarData : [
            {
                "employeeIdu": "7fb57592-f56c-406c-b48d-bc509ffc4696",
                "scheduleDate": "11/1/2020 12:00:00 AM",
                "shiftCodeId": "26",
                "shiftId": "NS"
            },
            {
                "employeeIdu": "7fb57592-f56c-406c-b48d-bc509ffc4696",
                "scheduleDate": "11/1/2020 07:30:00 PM",
                "shiftCodeId": "26",
                "shiftId": "NS"
            }
        ];

        const events = processEvents && processEvents.map(el => Object.assign({}, { title: el.shiftId, start: moment(el.scheduleDate).format('YYYY-MM-DD'), end: moment(el.scheduleDate).format('YYYY-MM-DD') }, { ...el })) || [];
        
        return (
            <div className="p-col-12">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                <div className="card card-w-title" style={{ position: 'relative' }}>
                    <h1>Work Schedule</h1>



                    <div className="p-grid">
                        <div className="p-col-12">
                            <div className="p-grid mt1" style={{ alignItems: 'center' }}>
                                <div className="p-col-12 p-md-6">
                                    <Link to="/shift-approval-single">
                                        <Button label="Add Work Schedule-Single Employee" icon="pi pi-plus" className="ml1" />
                                    </Link>
                                </div>
                                <div className="p-col-12 p-md-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Dropdown
                                        placeholder="View As"
                                        value={viewAs}
                                        name="viewAs"
                                        options={viewAsOptions}
                                        onChange={e => this.setState({ viewAs: e.target.value })}
                                        autoWidth={false}
                                        className="p-col-12" />
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <div className="p-grid">
                                <div className="p-col-6">
                                    
                                </div>
                                {viewAs === 'table' ?
                                    <div className="p-col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        {/* <Button style={{ float: 'right' }} label="Delete" icon="pi pi-trash" className="p-button-danger" /> */}
                                    </div> :
                                    <div className="p-col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <DropdownList
                                            name="selectedEmployee"
                                            placeholder="Select Employee"
                                            value={this.state.selectedEmployee}
                                            onDropdownChange={DropdownChange}
                                        />
                                    </div>}
                            </div>
                        </div>
                        <div className="p-col-12">
                            {viewAs === 'table' &&
                                <DataTable
                                    value={data}
                                    responsive
                                    className="p-datatable-customers animated fadeIn"
                                    rowHover
                                    selection={this.state.selectedCustomers}
                                    onSelectionChange={e => this.setState({ selectedCustomers: e.value })}
                                    paginator
                                    rows={10}
                                    emptyMessage="No lists found"
                                    globalFilter={this.state.globalFilter}
                                    header={this.renderHeader()} >
                                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                                    <Column field="requestNum" sortable={true} header="Request No." />
                                    <Column field="requesterName" sortable={true} header="Requester Name" style={{ width: '180px' }} />
                                    <Column field="requestDate" sortable={true} header="Request Date" />
                                    <Column field="remark" sortable={true} header="Remarks" />
                                    <Column field="pendingWith" sortable={true} header="Pending With" />
                                    <Column field="status" sortable={true} header="Status" body={this.statusRender} />
                                    <Column body={this.actionTemplate} header="Action" style={{ textAlign: 'center', width: '8em' }} />
                                </DataTable> ||
                                <FullCalendar
                                    ref={this.calendarRef}
                                    events={events}
                                    options={this.state.options}
                                    eventLimit={4}
                                    eventPropGetter={event => {
                                        const eventData = this.state.options.find(ot => ot.id === event.id);
                                        const backgroundColor = eventData && eventData.color;
                                        return { style: { backgroundColor } };
                                    }} />}
                        </div>
                    </div>


                </div>


            </div>

        );
    }


}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userPref: state.auth.userPref,
        loading: state.master.loading,
        error: state.master.error,
        requestListData: state.master.requestListData,
        calendarData: state.master.calendarData
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getRequest: (value,processid) => dispatch(actions.getRequest(value,'DB5BCCF0-4446-464E-BA88-28991BD6ACEC')),
        getCalendarData: (empId, model, fromDate, toDate) => dispatch(actions.getCalendarData(empId, model, fromDate, toDate))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkShedule);